export const CONSTANTS = {
  BASE_API: "https://api.dirkfu.com",
  LOGIN_API: "https://api.dirkfu.com/login",
  BUILDS: "https://api.dirkfu.com/builds/all",
  DOWNLOAD_BUILD: "https://api.dirkfu.com/builds/download/",
  AUTH_TOKEN: "AUTH_TOKEN"
};
